
import React from 'react';
import { CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { LucideIcon } from 'lucide-react';

interface CampaignHeaderProps {
  title: string;
  icon?: LucideIcon;
  description?: string;
}

const CampaignHeader: React.FC<CampaignHeaderProps> = ({ 
  title, 
  icon: Icon,
  description 
}) => {
  return (
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        {Icon && <Icon className="h-5 w-5" />}
        {title}
      </CardTitle>
      {description && <CardDescription>{description}</CardDescription>}
    </CardHeader>
  );
};

export default CampaignHeader;
